<template>
  <div class="p-custom">
    <div class="p-block">
      <div class="p-custom-list">
        <List :needLoadMore="false" :listParamsPos="listParamsPos" />
      </div>
      <Roll />
      <!-- <div class="p-block-more">
        <kd-link type="primary" @click="toCustom">
          <KdIcon
            icon="ArrowRightS"
            :size="24"
            fill="currentColor"
            margin="0 0 0 3px"
            leftText="了解更多客户案例"
            textSize="18"
          ></KdIcon>
        </kd-link>
      </div> -->
    </div>
  </div>
</template>

<script>
import { customData } from '@/views/homeV2/config.js';
import List from '@/views/case/src/components/List.vue';
import Roll from '@/components/Roll/index.vue';
import KdIcon from '@/components/KdIcon/index.vue';

export default {
  name: 'custom-component',
  components: { List, Roll, KdIcon },
  data() {
    return {
      baseData: customData,
      customRequestData: null,
      listParamsPos: [
        'official_website_home_casemodule_christianity',
        'official_website_home_casemodule_higheducation',
      ],
    };
  },
  methods: {
    toCustom() {
      this.$emit('homeCallback', {
        banOpen: true,
        dwClickName: 'more_customer_case',
      });
      this.$router.push('/case');
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.p-custom {
  .p-block {
    margin-bottom: 32px;
  }
  &-list {
    min-height: 345px;
  }
}
</style>
